import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const modal = () => {
    const modalElement = document.getElementById('js-modal');
    const modalOpenButton = document.getElementById('js-modal-open');
    const modalCloseButton = document.getElementById('js-modal-close');

    if (!modalElement || !modalOpenButton || !modalCloseButton) return;

    // モーダルを開く
    modalOpenButton.addEventListener('click', () => {
        modalElement.style.display = 'flex'; // モーダルを表示
    });

    // モーダルを閉じる
    modalCloseButton.addEventListener('click', () => {
        modalElement.style.display = 'none'; // モーダルを非表示
    });

    // 背景をクリックしてモーダルを閉じる
    modalElement.addEventListener('click', (event) => {
        if (event.target === modalElement) {
            modalElement.style.display = 'none';
        }
    });
};

const gallery = () => {
    $('.js-news-gallery-slider').each((_, slider) => {
        const $slider = $(slider);
        if ($slider.hasClass('slick-initialized')) return;

        const $gallery = $slider.closest('.pg-news-detail-gallery');
        const slideCount = $slider.find('.pg-news-detail-gallery__slide').length;
        const hasMultipleSlides = slideCount > 1;

        $slider.on('init afterChange', (event, slick, currentSlide = 0) => {
            $gallery
                .find('.pg-news-detail-gallery__thumbnail button')
                .removeAttr('aria-selected')
                .eq(currentSlide)
                .attr('aria-selected', 'true');
        });

        $slider.slick({
            slidesToShow: 1,
            autoplay: false,
            speed: 400,
            infinite: hasMultipleSlides,
            arrows: hasMultipleSlides,
            dots: hasMultipleSlides,
            appendDots: $gallery.find('.js-news-gallery-dots'),
            dotsClass: 'pg-news-detail-gallery__dot-list',
            prevArrow: '<button class="pg-news-detail-gallery__arrow pg-news-detail-gallery__arrow--prev" type="button" aria-label="前の画像"></button>',
            nextArrow: '<button class="pg-news-detail-gallery__arrow pg-news-detail-gallery__arrow--next" type="button" aria-label="次の画像"></button>',
            customPaging: (slick, index) => `<button type="button" aria-label="画像${index + 1}を表示"></button>`,
        });

        $gallery.find('.pg-news-detail-gallery__thumbnail button').on('click', (event) => {
            const index = $(event.currentTarget).closest('.pg-news-detail-gallery__thumbnail').index();
            $slider.slick('slickGoTo', index);
        });
    });
};

const tableWrap = () => {
    const tables = document.querySelectorAll('table');
    if (tables.length === 0) return;
    tables.forEach((table) => {
        const tableWrap = document.createElement('div');
        tableWrap.classList.add('table-wrap');
        table.parentNode.insertBefore(tableWrap, table);
        tableWrap.appendChild(table);
    });
};

const main = () => {
    if (document.querySelector('#page-news') === null) return;
    modal();
    gallery();
    tableWrap();
};

export default main;
